<template>
    <LoadingCard v-if="loading" />
    <div class="content__inner" v-else>
        <header class="content__title pl-0">
            <h1>Purchase History</h1>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">Chemical Purchases</h5>
                <b-pagination align="right" class="my-auto ml-auto mr-2" :total-rows="pagination.total" v-model="pagination.page"
                              :per-page="pagination.limit" />
                <!--<b-button variant="orange btn&#45;&#45;icon mr-2" size="sm"-->
                <!--v-if="dateRange"-->
                <!--@click="attemptExport"-->
                <!--v-b-tooltip="'Download Purchase History'">-->
                <!--<i class="zmdi zmdi-download"></i>-->
                <!--</b-button>-->
            </div>
            <VueDatePicker
                    id="date"
                    :config="dateRangeConfig"
                    v-model="dateRange"
                    class="form-control form-control-lg text-center bg-light"
                    placeholder="Click to filter entries by purchase date"
                    name="date" />

            <b-table :items="tableData" :fields="purchaseHistoryTable.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">

                <template slot="purchased_on" slot-scope="row">
                    <span class="text-nowrap">{{ row.item.purchased_on | date_format }}</span>
                </template>

                <template slot="chemicals" slot-scope="row">
                    <span v-for="entry in [...row.item.entries].sort((a,b) => a.chemical.name.localeCompare(b.chemical.name))"
                          class="badge badge-light mr-1 mb-1">
                        {{ entry.chemical.name }}
                    </span>

                    <span v-for="entry in [...row.item.fertilisers].sort((a,b) => a.fertiliser.name.localeCompare(b.fertiliser.name))"
                          class="badge badge-purple mr-1 mb-1">
                        {{ entry.fertiliser.name }}
                    </span>
                </template>

                <template slot="expand" slot-scope="row">
                    <b-button variant="secondary" size="sm" @click.stop="row.toggleDetails">
                        {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                    </b-button>
                </template>

                <template slot="row-details" slot-scope="row">

                    <b-button variant="outline-secondary" class="btn-block" size="sm":to="{name: 'stock-management', params: {view: 'purchase-input', id: row.item.id}}">
                        <i class="zmdi zmdi-edit"></i> Edit this Purchase Input
                    </b-button>

                    <b-table small :items="row.item.entities" :fields="entriesTable.fields" :show-empty="true">
                        <template slot="chemical_or_fertiliser" slot-scope="entry">
                             {{ (entry.item.chemical || entry.item.fertiliser).name }}
                        </template>
                        <template slot="type" slot-scope="entry">
                            {{ entry.item.type }}
                        </template>
                        <template slot="container_price" slot-scope="entry">
                            {{ entry.item.container_price | money_format }}
                        </template>
                        <template slot="container_count" slot-scope="entry">
                            {{ entry.item.container_count | number_format }}
                        </template>
                        <template slot="container_volume" slot-scope="entry">
                            {{ entry.item.container_volume | number_format }}
                        </template>
                    </b-table>
                </template>
            </b-table>
        </div>

    </div>
</template>

<script>
import listChemicalPurchasesQuery from '@views/StockManagement/PurchaseHistoryManager/queryListChemicalPurchases.graphql';

export default {
  name: 'PurchaseHistoryManager',
  apollo: {
    chemicalPurchases: {
      query: listChemicalPurchasesQuery,
      variables() {
        const variables = { input: {} };

        if (this.hasDateRange) {
          variables.input.purchased_on_gte = this.startDate;
          variables.input.purchased_on_lte = this.endDate;
        }

        return variables;
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.chemicalPurchases = data.filterChemicalPurchases.data;
          this.pagination.total = data.filterChemicalPurchases.meta.total;
        }
      },
    },
  },
  data() {
    return {
      loading: 0,
      chemicalPurchases: [],
      dateRange: null,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      dateRangeConfig: {
        mode: 'range',
        altInput: true,
        enableTime: false,
        nextArrow: '<i class="zmdi zmdi-long-arrow-right" />',
        prevArrow: '<i class="zmdi zmdi-long-arrow-left" />',
        altFormat: 'M j, Y',
        dateFormat: 'Y-m-d',
      },
      purchaseHistoryTable: {
        fields: [
          { key: 'purchased_on', label: 'Purchase Date' },
          { key: 'chemicals', label: 'Chemicals', class: 'd-print-none' },
          { key: 'comments', label: 'Comments' },
          { key: 'expand', label: ' ', class: 'd-print-none' },
        ],
      },
      entriesTable: {
        fields: [
          { key: 'chemical_or_fertiliser', label: 'Purchased' },
          { key: 'type', label: 'Type' },
          { key: 'container_price', label: '$/Container' },
          { key: 'container_count', label: 'Num. Containers' },
          { key: 'container_volume', label: 'Container Volume' },
        ],
      },
    };
  },
  computed: {
    startDate() {
      if (!this.dateRange || !this.dateRange.includes(' to ')) {
        return null;
      }

      return `${this.dateRange.split(' to ')[0]} 00:00:00`;
    },
    endDate() {
      if (!this.dateRange || !this.dateRange.includes(' to ')) {
        return null;
      }

      return `${this.dateRange.split(' to ')[1]} 23:59:59`;
    },
    hasDateRange() {
      return this.startDate && this.endDate;
    },
    tableData() {
      return this.chemicalPurchases.map(item => ({
        ...item,
        entities: [
          ...item.entries.map(entry => ({...entry, type: 'chemical'})),
          ...item.fertilisers.map(entry => ({...entry, type: 'fertiliser'})),
        ].sort((a,b) => (a.chemical || a.fertiliser).name.localeCompare((b.chemical || b.fertiliser).name)),
        _showDetails: false,
      }));
    },
  },
  methods: {
    attemptExport() {
    },
  },
};
</script>
